import * as T from '../../../components/Table'

export function ItemControleCompreGanhe({ product }) {
  return (
    <T.Tr>
      <T.Td py={1} borderRight="1px solid #cfcfcf!important">
        {product.NOME}
      </T.Td>
      <T.Td py={1} borderRight="1px solid #cfcfcf!important">
        {product.DT_ENTRADA}
      </T.Td>
      <T.Td py={1} borderRight="1px solid #cfcfcf!important">
        {product.DT_CAD}
      </T.Td>
      <T.Td py={1} borderRight="1px solid #cfcfcf!important">
        {product.QTD_ESTOQUE}
      </T.Td>
      <T.Td py={1}>{product.QTD_MIN_ESTOQUE}</T.Td>
      <T.Td py={1}>{product.REESTOCAR ? 'Sim' : 'Não'}</T.Td>
    </T.Tr>
  )
}
